module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }